<template>
  <transition name="slide2">
  <div class="contenedor-sitebar" v-if="menu">
     <Vehiculo  v-if="type=='vehiculo'" :datos="seleccion"/>
     <Conductores v-if="type=='conductores'"  :datos="seleccion"/>
     <Asignaciones v-if="type=='asignaciones'" :datos="seleccion"/>
     <Usuarios v-if="type == 'usuario'" :datos="seleccion" />
     <UsuariosApp v-if="type == 'usuariosapp'" :datos="seleccion" />
  </div>
  </transition>
</template>

<script>

import Vehiculo from './single/vehiculo'
import Conductores from './single/conductores'
import Asignaciones from './single/asignaciones'
import Usuarios from './single/usuarios'
import UsuariosApp from './single/usuariosapp'

export default {

    components:{
        Vehiculo,
        Conductores,
        Asignaciones,
        Usuarios,
        UsuariosApp
    },
     props:{
         type:'',
     },
     data(){
       return {
         
       }
     },

     computed:{

         seleccion(){
             return this.$store.state.select_table;
         },

         menu(){
            return this.$store.state.menusingleequipo;
        }

     }
}
</script>
<style>

        .contenedor-sitebar{

        position: fixed;
        right: 0;
        top:0;
        z-index: 99;
        height: 100%;
        width: 30%;
        background-color: white;
        box-shadow: 2px 5px 10px gray;
      

    }

</style>